import React, { Component } from 'react';

import PropTypes from 'prop-types';

import AnimationView from './index';

class BlinkView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
  }

  componentDidMount = () => {
    this.setBlinkInterval();
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
  };

  setBlinkInterval = () => {
    const { blinkRate } = this.props;
    this.interval = setInterval(() => {
      this.setState({ visible: !this.state.visible });
    }, blinkRate);
  };

  render() {
    const { style } = this.props;
    const { disabled, from, to } = this.props;
    if (disabled) {
      return this.props.children;
    }
    return (
      <AnimationView
        style={style}
        run={this.state.visible}
        effect="opacity"
        from={this.state.visible ? from : to}
        to={this.state.visible ? to : from}
        duration={this.props.blinkRate / 2}
        oneWay
      >
        {this.props.children}
      </AnimationView>
    );
  }
}

BlinkView.defaultProps = {
  disabled: false,
  blinkRate: 300,
  from: 0.4,
  to: 1,
};

BlinkView.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  from: PropTypes.number,
  to: PropTypes.number,
  blinkRate: PropTypes.number,
};

export default BlinkView;
